'use client';

import { type ComponentProps, type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

type PlaybackCardProps = ComponentProps<'video'>;

export function PlaybackCard({
    autoPlay = true,
    muted = true,
    loop = true,
    controls = true,
    className,
    ...rest
}: PlaybackCardProps): JSX.Element {
    return (
        <video
            className={twMerge(
                'w-full aspect-video bg-black rounded-sm border border-white/20 overflow-hidden object-contain',
                className,
            )}
            {...rest}
            autoPlay={autoPlay}
            preload="metadata"
            muted={muted}
            loop={loop}
            controls={controls}
            playsInline
        />
    );
}
